import React from 'react';
import { useTranslation } from 'react-i18next';
import PageSection from 'components/PageSection';
import SEO from 'components/SEO';
import { SectionTitle } from 'components/Typography';
import notFoundImg from 'assets/images/notfound-img.png';
import appConfig from 'config/appConfig';
import Button from 'components/Button';
import LocalizedLink from 'components/LocalizedLink';
import { paths } from 'constants';

const NotFound = () => {
    const { t } = useTranslation('misc');
    return (
        <PageSection
            color="inverted"
            element="main"
            className={`pb-16 lg:pb-32 border-b-1 border-primary-300 ${
                appConfig.layout.header.fixed ? 'pt-12 lg:pt-16' : 'pt-4 lg:pt-8'
            }`}
            containerClass="flex flex-col md:flex-row gap-16"
        >
            <SEO title={t('notFound.meta.title')} description={t('notFound.meta.description')} />
            <div className="flex-1 flex flex-col items-center md:items-start lg:items-center gap-4">
                <SectionTitle className="text-white">{t('notFound.eyebrow')}</SectionTitle>
                <p className="text-9xl md:text-[150px] lg:text-[250px] md:leading-[150px] lg:leading-[250px] font-bold text-secondary">
                    404
                </p>
                <SectionTitle className="text-white">{t('notFound.title')}</SectionTitle>
                <p className="text-center md:text-left lg:text-center">{t('notFound.body')}</p>
                <LocalizedLink to={paths.home}>
                    <Button color="secondary" element="div">
                        {t('notFound.cta')}
                    </Button>
                </LocalizedLink>
            </div>
            <div className="flex-1 hidden md:flex items-center justify-center">
                <img src={notFoundImg} alt="" />
            </div>
        </PageSection>
    );
};

export default NotFound;
